export default __webpack_public_path__ + "static/media/rnr-sports-table-1.6b646d4d.webp";